import React from 'react';
import ChiplessMark from './ChiplessMark';

// Chipless mark + "Chipless" wordmark. Single canonical mark used in every
// screen's top bar. The mark is taller than it is wide, so both dimensions are
// pinned explicitly to keep its aspect ratio in a flex row.
export default function Wordmark({ className = '', size = 'md' }) {
  const mark = size === 'sm' ? 'w-[11px] h-[14px]' : 'w-[17px] h-[22px]';
  const text = size === 'sm' ? 'text-[13px]' : 'text-[20px]';
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <ChiplessMark aria-hidden className={`${mark} shrink-0 text-ink`} />
      <span className={`${text} font-medium tracking-tight text-ink`}>Chipless</span>
    </div>
  );
}
